'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Drawer = require('./Drawer');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Drawer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Drawer/index.js
// module id = 151
// module chunks = 0